import XLSX from "xlsx";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date = new Date(time);
    if (!date) {
        if (typeof time === 'object') {
            date = time
        } else {
            if ((typeof time === 'string')) {
                if ((/^[0-9]+$/.test(time))) {
                    // support "1548221490638"
                    time = parseInt(time)
                } else {
                    // support safari
                    // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                    time = time.replace(new RegExp(/-/gm), '/')
                }
            }

            if ((typeof time === 'number') && (time.toString().length === 10)) {
                time = time * 1000
            }
            date = new Date(time)
        }
    }

    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
* @param {number} time
* @param {string} option
* @returns {string}
*/
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/***
 * 调整一个字段 匹配范围
 */

export function deletePropery(list, object, arr) {
    for (let property of arr) {
        // indexOf 找不到索引时返回 -1， 是数组最后一个值；
        let index = list.indexOf(property);
        list[index] = list[list.length - 1];
        list.pop();
        // 删除对象不存在的对象 回返回true,成功删除也返回true;
        // 似乎在js哪个新的内容出来之前，delete是最安全的操作，
        delete object[property];
    }
    return { list, object };
};

/**
 * 只赋值对象属性，不复制值；
 * This is just a simple version of deep copy,
 * copy key, without value;
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepCloneWithoutValue(source) {
    if (!source && typeof source !== "object") {
        throw new Error("error arguments", "deepClone");
    }
    const targetObj = source.constructor === Array ? [] : {};

    Object.keys(source).forEach(keys => {
        if (source[keys] && source[keys].constructor === Array) {
            targetObj[keys] = [];
        } else if (source[keys] && typeof source[keys] === "object") {
            targetObj[keys] = deepCloneWithoutValue(source[keys]);
        } else {
            targetObj[keys] = undefined;
        }
    });

    return targetObj;
}

export function collectApiParam(Desc, actionList) {
    let param = {};
    for (let item of actionList) {
        let item_api = item.url + "_api";;
        param[item_api] = deepCloneWithoutValue(Desc[item_api].param, true);
    }
    return param;
}



// 解析excel 返回数组
export async function resolvingXLSX(file, fields) {
    let list = []
    let data = await FunctionReadFile(file)
    const workbook = XLSX.read(data.target.result, { type: "binary" })
    for (let sheet in workbook.Sheets) {
        const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
        //若当前sheet没有数据，则continue
        if (sheetArray.length == 0) {
            continue;
        }
        // sheetArray是对象数组，每一行的数据是个对象
        // let descFields = sheetArray.shift();// 删除第一行
        // XLSX 直接将第一的数据当做对象的属性名
        for (let item of sheetArray) {
            //循环读取 每一行
            let rowTable = {};
            for (let key in fields) {
                let field = fields[key]
                rowTable[key] =
                    item[field] !== undefined
                        ? item[field]
                        : ""
            }
            list.push(rowTable)
        }
    }
    return list
}

function FunctionReadFile(file) {
    let fileReader = new FileReader()
    return new Promise(function (resolve, reject) {
        fileReader.onload = e => {
            if (e.type === "load") {
                resolve(e);
            } else {
                reject(e);
            }
        };
        fileReader.readAsBinaryString(file);
    });
}

export function isNumber(value) {
    typeof value === 'number'
}

export function noop() { }

/**
 * 下拉项的值添加“_api”后缀
 * @param {*} action 
 */
export function actionToApi(action) {
    return action + "_api";
}

export function getTime(date) {
    let t = new Date(date);
    if (!t) new Error('时间格式有误');
    return t.getTime();
}

/**
 * arr去重
 * @returns 
 */
export function getdedupl(arr) {
    return Array.from(new Set(arr));
}

export function getAfTime() {
    var t = 2
    var d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth() + 1
    var date = d.getDate()

    var datec = new Date(year, month + t, date)
    var yearc = datec.getFullYear()
    var monthc = datec.getMonth()
    var dayc = datec.getDate()
    return year + '-' + monthc + '-' + dayc
}

export function tHght(o) {
	return document.body.clientHeight - (o ? o : 0)
}

export function getAddrs(adr) {
    let reg = /.+?(省|市|自治区|自治州|县|区)/g
    return adr.match(reg)
}

export function getcurday() {
    let d = new Date()
    let year = d.getFullYear()
    let month = d.getMonth() + 1
    let day = d.getDate()

    return year + '-' + (month < 10 ? ('0'+month) : month) + '-' + (day < 10 ? ('0'+day) : day)
}

export function getcurmonth() {
    let d = new Date()
    let year = d.getFullYear()
    let month = d.getMonth() + 1

    return year + '-' + (month < 10 ? ('0'+month) : month)
}

export function tFixd(number, n) {
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (n) == 'undefined' || n == 0) {
        return (Math.round(number)).toString()
    }
    let result = number.toString()
    const arr = result.split('.')
    if (arr.length < 2) {
        result += '.'
        for (let i = 0; i < n; i += 1) {
            result += '0'
        }
        return result
    }
    const integer = arr[0]
    const decimal = arr[1]
    if (decimal.length == n) {
        return result
    }
    if (decimal.length < n) {
        for (let i = 0; i < n - decimal.length; i += 1) {
            result += '0'
        }
        return result
    }
    result = integer + '.' + decimal.substr(0, n)
    const last = decimal.substr(n, 1)
    if (parseInt(last, 10) >= 5) {
        const x = Math.pow(10, n)
        result = (Math.round((parseFloat(result) * x)) + 1) / x
        result = result.toFixed(n)
    }
    
    return result
}

export function getBrwPsh() {
    if (window.Notification) {
        // 支持弹出框
    } else {
        // 不支持
    }
    if(window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function(status) {
            if (status === "granted") {
                    new Notification('标题', {
                        body: '内容！',
                    })
            } else {
                // 当前的浏览器不支持消息通知！！！
            }
        })
    }
}

export function getQueryUrl(url, p) {
    let params = new URLSearchParams(url)

    return params.get(p)
}

export function downloadfile(url, title) {
    const a = document.createElement('a')
    a.href = url
    a.download = title || ''
    a.target = '_blank'
    a.rel = 'noopener'
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}



// WEBPACK FOOTER //
// ./src/utils/index.js